// The My Eco Engineer content architecture: five connected types of work.
// Ordered as a progression: Learn -> Think -> Plan -> Implement -> Integrate.
import { BookOpen, GitBranch, LayoutTemplate, Wrench, Boxes } from "lucide-react";

export const CONTENT_TYPES = [
  {
    key: "greenpapers",
    name: "Greenpapers",
    icon: BookOpen,
    color: "#00E599",
    step: "Learn",
    fits: "explain",
    category: "Foundation",
    tagline: "Educational publications",
    desc: "Research-backed educational publications that explain environmental health topics and the science behind cumulative exposure.",
    items: ["Decision Systems", "Home Systems", "Body Inputs", "Beyond the Home"],
    status: "Free",
    to: "/greenpapers",
    cta: "Read the Greenpapers",
  },
  {
    key: "frameworks",
    name: "Frameworks",
    icon: GitBranch,
    color: "#43C6F0",
    step: "Think",
    fits: "organize",
    category: "Product",
    tagline: "Decision-making models",
    desc: "Structured decision models that help you evaluate tradeoffs, prioritize actions, and think systematically.",
    items: ["Cumulative Exposure Framework", "Product Evaluation Framework", "Decision Prioritization Framework"],
    status: "In development",
    to: "/products/cognitive-load-allocation-framework",
    cta: "Explore the Frameworks",
  },
  {
    key: "blueprints",
    name: "Blueprints",
    icon: LayoutTemplate,
    color: "#FFB259",
    step: "Plan",
    fits: "plan",
    category: "Product",
    tagline: "Implementation guides",
    desc: "Comprehensive implementation guides that translate decisions into practical plans for specific environments or problems.",
    items: ["Low-Tox Home Blueprint", "Kitchen Blueprint", "Air Quality Blueprint", "Water Blueprint", "Nursery Blueprint"],
    status: "From $247",
    to: "/products/low-tox-home-blueprint",
    cta: "View the Low-Tox Home Blueprint",
  },
  {
    key: "toolkits",
    name: "Toolkits",
    icon: Wrench,
    color: "#B98CFF",
    step: "Implement",
    fits: "implement",
    category: "Product",
    tagline: "Practical resources",
    desc: "Checklists, worksheets, templates, calculators, and buying guides that support implementation.",
    items: ["Checklists", "Worksheets", "Templates", "Calculators", "Buying Guides"],
    status: "Free + Paid",
    to: "/resources/quick-start-checklist",
    cta: "Open the Quick-Start Checklist",
  },
  {
    key: "systems",
    name: "Systems",
    icon: Boxes,
    color: "#00E599",
    step: "Integrate",
    fits: "integrate",
    category: "Product + Service",
    tagline: "Integrated solutions",
    desc: "Integrated solutions that combine Greenpapers, Frameworks, Blueprints, and Toolkits into a complete end-to-end implementation strategy.",
    items: ["Low-Tox Home System", "Cognitive Load System"],
    status: "Done-with-you",
    to: "/services",
    cta: "Work with us on a full system",
  },
];

export const typeColor = (name) =>
  ({ Greenpaper: "#00E599", Blueprint: "#FFB259", Framework: "#43C6F0", Toolkit: "#B98CFF", System: "#00E599" }[name] || "#00E599");
